var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.conflicts),function(conflict,i){return _c('p',{key:i,staticStyle:{"color":"red"}},[_vm._v(" Warning! "+_vm._s(conflict[0])+" and "+_vm._s(conflict[1])+" are in the same time slot! ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }